import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Box, Stack, Typography } from '@mui/material';
import { type ReactNode } from 'react';

type AccordionWithHeadingProps = {
  readonly heading: ReactNode;
  readonly subheading?: ReactNode;
  readonly defaultExpanded?: boolean;
  readonly bordered?: boolean;
  readonly grow?: boolean;
  readonly noAccordion?: boolean;
  readonly children: ReactNode | ReactNode[];
};

export const AccordionWithHeading = ({
  heading,
  subheading,
  defaultExpanded = true,
  bordered = true,
  grow = false,
  noAccordion = false,
  children,
}: AccordionWithHeadingProps) => {
  if (noAccordion) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        flex="1 1 auto"
        position="relative"
        sx={{ border: '1px solid', borderRadius: '8px', borderColor: 'border.default', pt: 2.5, pb: 3, px: 3 }}
      >
        <>
          <Box pb={2.5}>{heading}</Box>
          {children}
        </>
      </Box>
    );
  }

  return (
    <Accordion
      disableGutters
      defaultExpanded={defaultExpanded}
      sx={{
        '&:before': {
          display: 'none',
        },
        padding: bordered ? 1 : 0,
        borderRadius: bordered ? '8px !important' : 0,
        border: bordered ? undefined : 'none',
        flexGrow: grow ? 1 : 0,
      }}
    >
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Stack>
          {typeof heading === 'string' ? (
            <Typography fontSize="14px" fontWeight="500">
              {heading}
            </Typography>
          ) : (
            heading
          )}
          {typeof subheading === 'string' ? (
            <Typography sx={{ color: 'text.secondary' }} fontSize="14px">
              {subheading}
            </Typography>
          ) : (
            subheading
          )}
        </Stack>
      </AccordionSummary>
      <AccordionDetails data-no-dnd="true">{children}</AccordionDetails>
    </Accordion>
  );
};
